import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

export const ModalBody = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    text-align: center;
    padding: 0 20px;
`;

export const SuccessTitle = styled.div`
    ${mixins.setFontVariant("h5", colorsPalettes.carbon[500])};
`;

export const SuccessSubtitle = styled.div`
    ${mixins.setFontVariant("body2", colorsPalettes.carbon[400])};
    margin-top: 12px;
`;

export const SuccessImageWrapper = styled.div`
    margin-bottom: 24px;
`;
